/**
 * The page and the name filter of a list of points read a page at a time (lib/iot/instrument-points): the filter as
 * typed, the query it settles into once typing pauses, and the page's offset, which goes back to the first page when
 * the query changes.
 */
import { useEffect, useState } from "react";

/** Wait this long after the last keystroke before asking the server for the filtered page. */
export const FILTER_SETTLE_MS = 300;

export function usePointsPage() {
  const [filter, setFilter] = useState("");
  const [query, setQuery] = useState("");
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const t = window.setTimeout(() => {
      setQuery(filter.trim());
      setOffset(0);
    }, FILTER_SETTLE_MS);
    return () => window.clearTimeout(t);
  }, [filter]);
  return { filter, setFilter, query, offset, setOffset };
}
